import React from 'react';

const GlobalContext = React.createContext({
    user: null,
})

export default GlobalContext;